import { Flex, Icon, Typography } from '@fe-toolkit/web-components/ssr'
import { ReactElement, ReactNode, useState } from 'react'
import styled from 'styled-components'

import theme from '@/theme/theme'

const DetailsContainer = styled.div`
  background-color: ${theme.colors.white};
`

export const SummaryContainer = styled.summary<{ $isOpen?: boolean }>`
  cursor: pointer;
  display: flex;
  padding: ${theme.spacing.small} ${theme.spacing.fine};
  justify-content: space-between;

  & svg {
    margin-right: ${theme.spacing.tiny};
    flex-shrink: 0;
    transition: transform 0.3s ease;
    transform: ${props => (props.$isOpen ? 'rotate(-180deg)' : 'rotate(0)')};
  }

  &:hover {
    outline: solid 4px ${theme.colors.lightBlue};
    outline-offset: 2px;
  }
`

export const ContentContainer = styled.div`
  padding: 0;
`

export type TInformativeAccordionProps = {
  children: ReactNode
  label: string
  secondaryLabel?: string
  open?: boolean
  testId?: string
}

const InformativeAccordion = ({
  children,
  label,
  secondaryLabel,
  open,
  testId,
}: TInformativeAccordionProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(open)

  const toggleOpen = () => setIsOpen(prev => !prev)

  return (
    <DetailsContainer>
      <SummaryContainer $isOpen={isOpen} aria-expanded={isOpen} data-testid={testId} onClick={toggleOpen}>
        <Flex flexDirection="column">
          <Typography as="span" sx={{ margin: `0 0 ${theme.spacing.small}` }} variant="speakUp">
            {label}
          </Typography>
          {secondaryLabel && (
            <Typography as="span" variant="murmur">
              {secondaryLabel}
            </Typography>
          )}
        </Flex>
        <Icon height={theme.iconSizes.medium} iconKey="ChevronTop" width={theme.iconSizes.medium} />
      </SummaryContainer>
      {isOpen && <ContentContainer role="region">{children}</ContentContainer>}
    </DetailsContainer>
  )
}

export default InformativeAccordion
